import type { TenantSignInProvider } from '@dawn/feature-config';
import { create } from 'zustand';

type TenantStatus = 'loading' | 'valid' | 'error';

/** `GET /company` response — public, so the sign-in provider only, never the IdP ids. */
export interface TenantCompany {
  name: string;
  identityPlatformTenantId?: string | null;
  /** Which login button to render (TDEV-156). Absent from older API responses → Google. */
  signInProvider?: TenantSignInProvider;
}

interface TenantState {
  status: TenantStatus;
  company: TenantCompany | null;
  error: string | null;
  setTenant: (company: TenantCompany) => void;
  setError: (error: string) => void;
  setLoading: () => void;
}

export const useTenantStore = create<TenantState>()((set) => ({
  status: 'loading',
  company: null,
  error: null,
  setTenant: (company) =>
    set({
      status: 'valid',
      company,
      error: null,
    }),
  setError: (error) =>
    set({
      status: 'error',
      company: null,
      error,
    }),
  setLoading: () =>
    set({
      status: 'loading',
      company: null,
      error: null,
    }),
}));
